/* eslint-disable fp/no-mutation */
export type FileData = {
  name: string
  type: string
  extension: string
  file: Blob | null
}

export type ContentType = 'application/pdf' | 'image/jpeg' | 'image/png'

export const contentTypes: ContentType[] = [
  'application/pdf',
  'image/jpeg',
  'image/png',
]

export const extensions: Record<ContentType, string> = {
  'application/pdf': 'pdf',
  'image/jpeg': 'jpeg',
  'image/png': 'png',
}

export function downloadFile(data: Blob | string, fileName: string) {
  let url = window.URL.createObjectURL(new Blob([data]))
  let link = document.createElement('a')
  link.href = url
  link.setAttribute('download', fileName)
  document.body.appendChild(link)
  link.click()
}

export function downloadFileFromURL(url: string, fileName: string) {
  let link = document.createElement('a')
  link.href = url
  link.setAttribute('download', fileName)
  document.body.appendChild(link)
  link.click()
}

export function handleImageCapture(
  event: React.ChangeEvent,
  setFile: React.Dispatch<React.SetStateAction<FileData | undefined>>,
  onError: (err: string) => void,
  allowedContentTypes: ContentType[] = contentTypes,
) {
  let file = (event.target as HTMLInputElement).files?.[0]
  let fileName = file?.name || ''
  let reader = new FileReader()

  reader.onloadend = () => {
    let fileData = reader.result?.toString()?.match(/data:[a-z]+\/[a-z]+/)?.[0]
    if (!fileData) {
      onError('Read File Failed')
      return
    }

    let fileType = fileData.split(':')[1]
    let fileExtension = fileType.split('/')[1]

    if (!allowedContentTypes.includes(fileType as ContentType)) {
      onError(`Invalid File Type ${fileType}`)
      return
    }

    let binary = atob(reader.result?.toString().split(',')[1] as string)
    let array = new Array(binary.length)
      .fill('')
      .map((_, i) => binary.charCodeAt(i))
    let blobData = new Blob([new Uint8Array(array)], { type: fileExtension })

    setFile({
      name: fileName,
      type: fileType,
      extension: fileExtension,
      file: blobData,
    })
  }

  reader.readAsDataURL(file!)
}
